import { ISagaCb } from '@typings/requestPayloads'
import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IDeleteTourPayload extends ISagaCb {
    id: string
}

export interface IDeleteTourState {
    status: string
    data: any
    errors: any
}

const initialState: IDeleteTourState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const deleteTour = createSlice({
    name: 'tour/delete',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IDeleteTourPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.response
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload.error
        }
    }
})

export const deleteTourActions = deleteTour.actions
export default deleteTour.reducer
